module.exports = __webpack_public_path__ + "media/site_templates/www.cabinetmaker.company/images/testimonials-e1ef259e03bfad3a5001e9187dc87b16.jpg";